// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3wiEj","options":"AnswerScale_options__3x5Yv","selected":"AnswerScale_selected__11ucH"};